"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
// needs a separate module as this is required inside chevrotain productive code
// and also in the entry point for webpack(api.ts).
// A separate file avoids cyclic dependencies and webpack errors.
exports.VERSION = "10.1.2";
//# sourceMappingURL=version.js.map